export const ROUTE_MAIN = 'main'
export const ROUTE_HOME = 'home'
export const ROUTE_CALLBACK_OIDC = 'callback'
export const ROUTE_CALLBACK_MSENTRA = 'callbackMSEntra'
